import { Heating } from "@/pages/eaf/data-entry/models/eaf.models";
import { EditAndDeleteButtons } from "@/shared/data-entries/EditAndDeleteButtons";
import { ManualAutoButton } from "@/shared/data-entries/ManualAutoButton";
import { dxtToLocalServerTime, getMomentTz } from "@dexteel/mesf-core";
import {
  ColDef,
  ColGroupDef,
  ICellRendererParams,
  ValueGetterParams,
} from "ag-grid-enterprise";

const moment = getMomentTz();

type Props = {
  deleteHeating: (heatingId: number) => void;
};

export const useTableData = ({ deleteHeating }: Props) => {
  const columns: ColGroupDef[] = [
    {
      headerName: "Heatings",
      children: [
        {
          field: "manual-auto",
          headerName: " ",
          flex: 1,
          cellRenderer: ManualAutoButton,
          cellRendererParams: (params: ICellRendererParams<Heating>) => ({
            isManual: (params.data as Heating).IsHeatingManual,
          }),
        },
        {
          field: "StartTime",
          headerName: "Start",
          flex: 2,
          valueGetter: (params: ValueGetterParams) => {
            if (params.data.StartTime) {
              return dxtToLocalServerTime(
                (params.data as Heating).StartTime,
                "HH:mm:ss",
              );
            }
          },
        },
        {
          field: "EndTime",
          headerName: "End",
          flex: 2,
          valueGetter: (params: ValueGetterParams) => {
            if (params.data.EndTime) {
              return dxtToLocalServerTime(
                (params.data as Heating).EndTime,
                "HH:mm:ss",
              );
            }
          },
        },
        {
          field: "Duration",
          headerName: "Duration",
          flex: 2,
          valueGetter: (params: ValueGetterParams) => {
            const { StartTime, EndTime } = params.data as Heating;

            if (EndTime && StartTime) {
              const durationInSeconds = moment(EndTime).diff(
                moment(StartTime),
                "seconds",
              );

              if (isNaN(durationInSeconds)) {
                return "";
              }
              const minutes = Math.floor(durationInSeconds / 60);
              const seconds = durationInSeconds % 60;
              return `${minutes.toString().padStart(2, "0")}:${seconds
                .toString()
                .padStart(2, "0")}`;
            }
          },
        },
        {
          field: "Energy",
          headerName: "Energy [kWh]",
          flex: 2,
        },
        {
          field: "actions",
          headerName: " ",
          flex: 2,
          cellRenderer: EditAndDeleteButtons,
          cellRendererParams: (params: ICellRendererParams<Heating>) => ({
            deleteItem: deleteHeating,
            id: (params.data as Heating).HeatingId,
            showEdit: false,
          }),
        },
      ],
    },
  ];

  return { columns };
};
